import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
//import { WriterComponent } from './writer/writer.component';
import { CoverComponent } from './cover/cover.component';
//import { TestComponent } from './test/test.component';
import { TemplateComponent } from './template/template.component';
import { ReportComponent } from './report/report.component';
import { CompanyComponent } from './company/company.component';
import { ReportresourcesComponent } from './reportresources/reportresources.component';
import { ErisOnlyComponent } from './eris-only/eris-only.component';
import { PhotologComponent } from './photolog/photolog.component';
import { CompleteComponent } from './complete/complete.component';
import { CompleteRptComponent } from './complete-rpt/complete-rpt.component';
import { CompleteTempComponent } from './complete-temp/complete-temp.component';

const routerOptions: ExtraOptions = {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    scrollOffset: [0, 64]
};

const routes: Routes = [
	//{path: ':r', component: DashboardComponent},
	{ path: '', component: DashboardComponent },
	//{ path: 'writer', component: WriterComponent },
	{ path: 'cover', component: CoverComponent },
	{ path: 'cover/:id', component: CoverComponent },
	//{ path: 'test', component: TestComponent },
	{ path: 'template', component: TemplateComponent },
	{ path: 'report', component: ReportComponent },
	{ path: 'company', component: CompanyComponent },
	{ path: 'complete', component: CompleteComponent },
	{ path: 'report/:project/:id', component: ReportComponent },
	{ path: 'complete-rpt', component: CompleteRptComponent },
	{ path: 'complete-rpt/:project/:id', component: CompleteRptComponent },
	{ path: 'template/:id', component: TemplateComponent },
	{ path: 'complete-temp', component: CompleteTempComponent },
	{ path: 'complete-temp/:id', component: CompleteTempComponent },	
	{ path: 'resources', component: ReportresourcesComponent },
	{ path: 'erisonly', component: ErisOnlyComponent },
	{ path: 'photolog/:project/:report', component: PhotologComponent },
	{ path: 'photolog/:project/:report/:photolog', component: PhotologComponent },
	//{ path: '', redirectTo: '/dashboard', pathMatch: 'full' },
	// otherwise redirect to login
	{ path: '**', redirectTo: '' },
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
	exports: [RouterModule]
})


export class AppRoutingModule { }
